import { SessionStoreModuleType } from "UidispatcherApiModule";
const { SessionStoreModule }: { SessionStoreModule: SessionStoreModuleType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export const SessionStore = SessionStoreModule.SessionStore;
export const LogoutManualAction = SessionStoreModule.LogoutManualAction;
